<template>
  <div>
    <span
      v-if="label"
      class="color-primary-4 font-16 font-weight-bold ml-4 pl-4 mb-4"
    >
      {{ label }}
    </span>
    <div class="d-flex align-items-center mt-2">
      <em
        v-if="icon"
        class="fa fa-user-circle h1 color-gray-10 mr-2 mt-2"
        :class="iconClass"
        @click="$emit('on-click-icon')"
      />
      <custom-input
        class="w-100 flex-1 custom-input__exteded"
        v-model="modelValue"
        novalidate
        :type="type"
        :error="error"
        :custom-error-msg="customErrorMsg"
        :maxlength="maxlength"
        @input="$emit('input', modelValue)"
      />
      <em
        v-if="rightIcon"
        class="h1 color-gray-10 mr-2 mt-2 custom-right-icon"
        :class="rightIcon"
        @click="$emit('on-click-right-icon')"
      />
    </div>
  </div>
</template>

<script>
import CustomInput from 'CustomInput';
export default {
  name: 'CustomFormInput',
  components: {
    CustomInput,
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'text',
    },
    icon: {
      type: String,
      default: '',
    },
    error: {
      type: String,
      default: '',
    },
    customErrorMsg: {
      type: String,
      default: '',
    },
    rightIcon: {
      type: String,
      defaul: '',
    },
    maxlength: {
      type: String,
      defaul: '',
    },
  },
  data() {
    return {
      modelValue: this.value,
      showPassword: false,
    };
  },
  computed: {
    iconClass() {
      return this.icon ? `fas fa-${this.icon}` : '';
    },
  },
  methods: {
    onShowHide() {
      this.showPassword = !this.showPassword;
    },
  },
};
</script>

<style scoped lang="scss">
.custom-input__exteded ::v-deep {
  .form-control {
    height: 52px;
    border: 1px solid #e4e4e4;
  }
  .input-group-prepend {
    background: transparent !important;
    position: absolute;
    top: 12px;
    right: 1px;
    z-index: 10;
    .input-group-text {
      background: transparent;
      border: unset;
      color: #dddddd;
    }
  }
}
.custom-right-icon {
  position: absolute !important;
  right: 36px;
  font-size: 16px;
}
</style>
